import { styled } from '@styles/stitches';

export const Content = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  maxHeight: '60vh',
  overflow: 'hidden',
  overflowY: 'auto',

  '@bp1': {
    height: 'unset',
    maxHeight: '50vh',
  },
});

export const Buttons = styled('div', {
  '& > *': {
    marginTop: '$space$4',
  },
});
